var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIconUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.20312 8.52L7.98562 3.91167C12.5098 -0.452497 19.8573 6.28084 15.149 10.8233L9.22229 16.5417C6.15229 19.5033 1.16646 14.9342 4.36146 11.8517L10.2031 6.21584C11.819 4.6575 14.4423 7.06167 12.7615 8.68417L7.90896 13.3333",
    stroke: "#FF78AA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIconUpload);
export default __webpack_public_path__ + "static/media/fileIconUpload.e2a77264320c80b03540114124464400.svg";
export { ForwardRef as ReactComponent };